import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

import React from "react";

import AuthFlowLoader from "../../AuthFlowLoader/AuthFlowLoader";
import Header from "../../NewHeader/Header";

const AuthenticationLayout = () => {
  // Verify if user if authenticated
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // If user is authenticated, send them to home
  return !isAuthenticated ? (
    <>
      <Header />
      <AuthFlowLoader />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default AuthenticationLayout;
